/** @file Formats a number for a field: rounded to the precision, trailing zeros dropped. */

/** Returns `value` rounded to `precision` decimals as text without trailing zeros ("1.50" becomes "1.5"). */
export function formatNumber(value: number, precision?: number): string {
  return String(precision === undefined ? value : Number(value.toFixed(precision)));
}
